import React, { useState } from 'react';

import { useTheme } from 'styled-components';

import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { BiSearch } from 'react-icons/bi';

import { Container } from './styles';

import { ItemProps } from './interface';

const GridHeadItem: React.FC<ItemProps> = ({
  title,
  width,
  onClick,
  active,
  order,
  children,
  isSearch,
  onSearch,
}) => {
  const { colors } = useTheme();

  const [searchText, setSearchText] = useState('');

  return (
    <Container active={active} width={width} onClick={onClick}>
      {isSearch && onSearch ? (
        <div>
          <span>{title || ''}</span>
          <input
            type="text"
            value={searchText}
            onChange={e => {
              setSearchText(e.target.value);
              onSearch(e.target.value);
            }}
          />
          <button
            type="button"
            onClick={() => onSearch(searchText)}
            className="search"
          >
            <BiSearch size={22} color="#333" />
          </button>
        </div>
      ) : (
        <>
          {title ? <span>{title}</span> : null}
          {active ? (
            <i>
              {order === 'desc' ? (
                <IoMdArrowDropup size={22} color={colors.GRID_MENU_IC} />
              ) : (
                <IoMdArrowDropdown size={22} color={colors.GRID_MENU_IC} />
              )}
            </i>
          ) : null}
          <>{children}</>
        </>
      )}
    </Container>
  );
};

export default GridHeadItem;
